export const shadows = {
    baseShadow: '0px 2px 20px rgba(0, 25, 55, 0.08)'
};
